import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { ssoCertificateValidator, urlValidator } from '#validation';
export const SsoConfigCreateSchema = z.object({
    idpEntityId: urlValidator({
        requiredError: 'sso.idpEntityId.required',
        formatError: 'sso.idpEntityId.format',
    }),
    signInUrl: urlValidator({
        requiredError: 'sso.signInUrl.required',
        formatError: 'sso.signInUrl.format',
    }),
    certificate: ssoCertificateValidator,
});
export class SsoConfigCreateDto extends createZodDto(SsoConfigCreateSchema) {
}
